import { PropsWithChildren } from "react";
import { Card } from "./Card";
import { Text } from "components/general/Text";
import { css } from "@emotion/react";
import { MOBILE_WIDTH } from "hooks/useDeviceType";

export const HomepageCard = ({
  title,
  body,
  color,
  children,
}: PropsWithChildren<{ title: string; body?: string; color: string }>) => {
  return (
    <Card title={title} color={color}>
      {body != null && (
        <Text textStyle="Paragraph" size="XXL" color="" textCss={cardTextCss} shouldScale={true}>
          {body}
        </Text>
      )}
      {children}
    </Card>
  );
};

// Sub-components

const cardTextCss = css`
  margin-bottom: 6px;
  @media (max-width: ${MOBILE_WIDTH}px) {
    font-size: 14px;
  }
`;
